import { i18n } from "translate/i18n";

export const delayedReadingModal = i18n.t("titles.delayedReadingModal");
export const subtitle = i18n.t("messages.delayedReadingModal.subtitle");
export const firstButton = i18n.t("buttons.delayedReadingModal.firstButton");
export const secondButton = i18n.t("buttons.delayedReadingModal.secondButton");
